import newsfeedPageWidgetsUrl from './newsfeed-page-widgets.html';
export default {
  controllerAs: 'ctrl',
  bindings: {
    page: '<',
  },
  controller: class {
    constructor(PersonaCollection) {
      'ngInject';

      Object.assign(this, { PersonaCollection });
    }

    isSubscribed = (member) => {
      if (this.page?.subscribers?.length) {
        return this.page?.subscribers?.findIndex((m) => m.id === member.id) > -1;
      }

      return false;
    };

    orderBySubscription = (member) => (this.isSubscribed(member) ? -1 : 1);

    get hasEveryoneGroup() {
      return !!this.page.personas.find((p) => p.id === this.PersonaCollection.everyone.id);
    }
  },
  templateUrl: newsfeedPageWidgetsUrl,
};
